// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.notification = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			notificationClass: 'notification--hide'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$close = $context.find('.close');
			settings.$confirm = $context.find('.confirm');
		};

		// Bind events
		methods.events = function() {

			$.merge(settings.$close, settings.$confirm).on('click', function(event) {
				event.preventDefault();

				// Assuming must have been done this way as there could be multiple notifications
				var notification = $(this).closest('.notification'),
					id = notification.attr('id');
				
				methods.setCookie(id, "confirmed", 14);
				notification.addClass(settings.notificationClass);
			});
		};

		methods.checkNotificationCookies = function() {

			$.each($context, function() {
				var $this = $(this);
				var id = $this.attr('id'),
					cookie = methods.getCookie(id);
					
				if (typeof cookie === 'undefined') {
					$this.removeClass(settings.notificationClass);
				}
			});
		}

		methods.getCookie = function(cname) {
			var name = cname + "=",
				ca = document.cookie.split(';');

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1);
				if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
			}
		}

		methods.setCookie = function(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + "; " + expires;
		}

		methods.initContext = function() {
			methods.setCurrentSettings();
			methods.checkNotificationCookies();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
	};

	if ($('.notification').length) {
		$('.notification').notification();
	}

}(jQuery));
